module.exports = __webpack_public_path__ + "img/Green.014a5ca1.png";